import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Table } from 'antd';
import { useForm, useWatch } from 'antd/es/form/Form';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { setModal } from '../../../../common/slices/commonSlice';
import { perProps } from '../../../../common/types/commonTypes';
import CommonTableHeader from '../../../../components/common/CommonTableHeader';
import { DateInput } from '../../../../components/common/FormItem/FormItems';
import { removeSpaceBeforeWord } from '../../../../components/common/Invoice/InvoiceListHeader';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import { IAccountNonInvoiceIncome } from '../../AccountsTypes/AccountsTypes';
import { useGetAllNonInvoiceIncomeQuery } from '../../Api/Endpoints/nonInvoiceIncomeEndpoints';
import Non_Invoice_Income_Add_Modal from '../../modals/Non_Invoice_Income/Non_Invoice_Income_Add_Modal';
import Non_Invoice_Income_Edit_Modal from '../../modals/Non_Invoice_Income/Non_Invoice_Income_Edit_Modal';
import { ListOfNonInvoiceIncomeColumn } from '../../utils/Non_Invoice_Income/ListOfNonInvoiceIncomeColumn';

const Non_Invoice_Income = ({ permission }: perProps) => {
  const dispatch = useAppDispatch();
  const searchParams = new URLSearchParams(location.search);
  const [search, setSearch] = useState('');

  const [form] = useForm();
  const date_range = useWatch('date_range', form) as string[] | undefined;

  const [editInfo, setEditInfo] = useState<IAccountNonInvoiceIncome | null>(
    null
  );

  useEffect(() => {
    const from_date = searchParams.get('from_date');
    const to_date = searchParams.get('to_date');

    if (from_date && to_date) {
      form.setFieldValue('date_range', [dayjs(from_date), dayjs(to_date)]);
    }
  }, []);

  // Handle Pagination
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });

  const handlePaginationChange = (current: number, pageSize: number) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current,
      pageSize,
    }));
  };

  const showModal = () => {
    dispatch(setModal(true));
  };

  const { data, isLoading, isError, isFetching, refetch } =
    useGetAllNonInvoiceIncomeQuery({
      ...pagination,
      from:
        (date_range?.[0] && dayjs(date_range[0]).format('YYYY-MM-DD')) || '',
      to: (date_range?.[1] && dayjs(date_range[1]).format('YYYY-MM-DD')) || '',
      search,
    });

  const handleSearch = (e: any) => {
    setSearch(removeSpaceBeforeWord(e.target.value));
  };
  return (
    <div>
      <BreadCrumb
        arrOfOption={['Accounts', 'Non Invoice Income']}
        refetch={() => refetch()}
        reloaderSize='small'
      />
      <Row justify={'space-between'} style={{ marginBottom: '1rem' }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 8 }}>
          {permission?.['create:any'] && (
            <Col>
              <Button type='primary' onClick={showModal}>
                <PlusOutlined />
                Add Non-Invoice Income
              </Button>
            </Col>
          )}
        </Row>

        <Col span={12}>
          <Form form={form}>
            <Row justify={'end'} gutter={10}>
              <Col xs={24} sm={12} md={8} lg={8}>
                <DateInput name={'date_range'} rangePicker size={24} />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <Input
                  placeholder='🔍 Search Here...'
                  onBlur={handleSearch}
                  onPressEnter={handleSearch}
                  allowClear
                ></Input>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>

      <CommonTableHeader
        title=''
        element={
          editInfo ? (
            <Non_Invoice_Income_Edit_Modal
              info={editInfo}
              setNull={setEditInfo}
            />
          ) : (
            <Non_Invoice_Income_Add_Modal />
          )
        }
        setNull={setEditInfo}
      />
      <Table
        size='small'
        bordered
        columns={ListOfNonInvoiceIncomeColumn({
          setEditInfo,
          showModal,
          permission,
          pagination,
        })}
        dataSource={data?.data}
        pagination={
          data?.count !== undefined && data?.count < 20
            ? false
            : {
                ...pagination,
                total: data?.count,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '200', '500'],
                onChange: handlePaginationChange,
              }
        }
        scroll={{ x: true }}
        loading={{
          spinning: isLoading || isFetching,
          indicator: loadingIndicator,
        }}
      />
    </div>
  );
};

export default Non_Invoice_Income;
